import { render, staticRenderFns } from "./CbsDataNewRecord.vue?vue&type=template&id=11cdad76&scoped=true"
import script from "./CbsDataNewRecord.vue?vue&type=script&lang=js"
export * from "./CbsDataNewRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cdad76",
  null
  
)

export default component.exports